import * as types from './mutation-types';

export default {
    [types.INCREMENT]({ commit }) {
        commit(types.INCREMENT);
    },
    [types.DECREMENT]({ commit }) {
        commit(types.DECREMENT);
    },
    [types.RESET]({ commit }) {
        commit(types.RESET);
    },
    [types.NEW_PREVIEW]({ commit }, payload) {
        commit(types.NEW_PREVIEW, payload.preview);
    },
    [types.FINISH_PREVIEW]({ commit }) {
        commit(types.FINISH_PREVIEW);
    },
    [types.INCREMENT_HEADERCOUNT]({ commit }) {
        commit(types.INCREMENT_HEADERCOUNT);
    },
    [types.RESET_HEADERCOUNT]({ commit }) {
        commit(types.RESET_HEADERCOUNT);
    },
    [types.RESET_HEADER]({ commit }) {
        commit(types.RESET_HEADER);
    },
    [types.INCREMENT_TILECOUNT]({ commit }) {
        commit(types.INCREMENT_TILECOUNT);
    },
    [types.RESET_TILECOUNT]({ commit }) {
        commit(types.RESET_TILECOUNT);
    },
    [types.SET_HEADER_URL]({ commit }, payload) {
        commit(types.SET_HEADER_URL, payload.preview);
    },
    [types.SET_HEADER_FILE]({ commit }, payload) {
        commit(types.SET_HEADER_FILE, payload);
    },
    [types.TILE_IMAGE_UPLOADED]({ commit }, payload) {
        commit(types.TILE_IMAGE_UPLOADED, payload);
    },
    [types.TILE_IMAGE_DELETED]({ commit }, payload) {
        commit(types.TILE_IMAGE_DELETED, payload);
    },
    [types.TILE_IMAGES_RESET]({ commit }) {
        commit(types.TILE_IMAGES_RESET);
    },
    [types.SET_EMAIL]({ commit }, payload) {
        commit(types.SET_EMAIL, payload.email);
    }
};
